<template>
  <v-row>
    <v-col cols="3">
      <v-skeleton-loader type="text" />
    </v-col>
    <v-col cols="8">
      <v-skeleton-loader type="text" />
    </v-col>
    <v-col cols="1">
      <v-skeleton-loader type="chip" />
    </v-col>

    <v-col cols="5">
      <v-skeleton-loader type="text" />
    </v-col>
    <v-col cols="7">
      <v-skeleton-loader type="text" />
    </v-col>

    <v-col cols="4" v-for="i in 3" :key="'horario' + i">
      <v-skeleton-loader type="text" />
    </v-col>

    <v-col cols="4" v-for="i in 3" :key="'tipo' + i">
      <v-skeleton-loader type="list-item" />
    </v-col>

    <v-col cols="4" v-for="i in 3" :key="'linha5' + i">
      <v-skeleton-loader type="text" />
    </v-col>

    <v-col cols="4">
      <v-skeleton-loader type="text" />
    </v-col>
    <v-col cols="4">
      <v-skeleton-loader type="text" />
    </v-col>
    <v-col cols="4"> </v-col>

    <v-col cols="12">
      <v-skeleton-loader type="button" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SkeletonTurmaForm",
};
</script>
